import React, { FunctionComponent } from 'react';

import NavBar from '../../layout/NavBar';

interface Props {}

const ClientNavbar: FunctionComponent<Props> = () => {

    return (
        <NavBar>
            {/* <NavLink to={'#favorites'}>Link</NavLink> */}
        </NavBar>
    );
};

export default ClientNavbar;
